import { showToast, validateEmail } from '@/partials/el.Utils.js';

const SELECTOR = {
  BACK_IN_STOCK_BTN: '.js-back-in-stock',
  TITLE_EL: '.js-product-title',
  CLOSE_BTN: '.js-close-button',
  TEMPLATE: 'template.js-template',
};

const COMPANY_ID = 'YsJjdr';

elabs.BackInStockPopover = class {
  constructor(element) {
    if (!element) {
      console.error('BackInStockPopover: Element not provided to constructor.');
      return;
    }
    this.view = element;
    const templateElement = this.view.querySelector(SELECTOR.TEMPLATE);
    if (!templateElement) {
      console.error('BackInStockPopover: Template element not found.');
      return;
    }
    this.templateContent = templateElement.content;
    this.inited = false;
  }

  show(payload) {
    if (!this.inited) {
      this.init(payload);
    }

    this.variantId = payload.variantId;
    this.titleElement.textContent = payload.title;
  }

  hide() {
    // This method is required by the manager but can be empty if no specific action is needed on hide.
  }

  init() {
    this.view.appendChild(this.templateContent.cloneNode(true));

    this.form = this.view.querySelector('form');
    this.titleElement = this.view.querySelector(SELECTOR.TITLE_EL);
    this.emailInput = this.form.querySelector('[type="email"]');
    this.emailSubmitButton = this.view.querySelector('.el-popover__newsletter-signup-button');

    const closeButton = this.view.querySelector(SELECTOR.CLOSE_BTN);

    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    closeButton.addEventListener('click', () => window.CenteredPopovers.wrapper.hide());

    this.emailInput.addEventListener('input', () => {
      this.toggleButtonVisibility();
    });

    window.addEventListener('CenteredPopoversWrapper:hide', () => {
      this.resetForm();
    });

    this.inited = true;
  }

  toggleButtonVisibility() {
    const hasText = this.emailInput.value.length > 0;
    this.emailSubmitButton.classList.toggle('is-visible', hasText);
  }

  async handleSubmit(e) {
    e.preventDefault();
    const email = this.emailInput.value.trim();

    if (!validateEmail(email)) {
      this.emailInput.classList.add('error');
      return;
    }
    this.emailInput.classList.remove('error');

    try {
      const res = await this.subscribeToKlaviyo({
        email,
        variantId: this.variantId,
      });

      let data = null;
      if (res.status !== 202 && res.status !== 204) {
        data = await res.json();
      }

      if (data?.errors?.length) {
        this.triggerToast({ success: false });
      } else {
        this.triggerToast({ success: true });
      }
    } catch (error) {
      this.triggerToast({ success: false });
      console.error('BackInStockPopover <handleSubmit> Error:', error);
    } finally {
      window.CenteredPopovers.wrapper.hide();
    }
  }

  subscribeToKlaviyo({ email, variantId }) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };
    return fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-12-15',
      },
      body: JSON.stringify(payload),
    });
  }

  triggerToast({ success } = {}) {
    if (success) {
      showToast('We’ll let you know if this product comes back into stock.', undefined, 9000);
    } else {
      showToast(
        'Creating a stock alert failed. Please try again, or contact customer services if the problem persists.',
      );
    }
  }

  resetForm() {
    if (this.form) {
      this.form.reset();
      this.emailInput.classList.remove('error');
    }
  }
};

elabs.onJavascriptReady(() => {
  const popoverElement = document.querySelector('[data-centered-popover="back-in-stock"]');
  if (!popoverElement) {
    return;
  }

  const registerPopover = () => {
    window.CenteredPopovers['back-in-stock'] = new elabs.BackInStockPopover(popoverElement);
  };

  if (window.__CenteredPopoversWrapperReady) {
    registerPopover();
  } else {
    window.addEventListener('CenteredPopoversWrapper:ready', registerPopover, { once: true });
  }
});
